import { type FormEvent, useState } from "react";
import { useAuth } from "../contexts/AuthContext";

export function LoginModal() {
	const { login } = useAuth();
	const [password, setPassword] = useState("");
	const [error, setError] = useState("");
	const [loading, setLoading] = useState(false);

	async function handleSubmit(e: FormEvent) {
		e.preventDefault();
		setError("");
		setLoading(true);

		const result = await login(password);

		if (!result.success) {
			setError(result.error || "Login failed");
			setLoading(false);
		}
	}

	return (
		<div className="login-overlay">
			<div className="login-modal">
				<h2>ELO Tracker Login</h2>
				<form onSubmit={handleSubmit}>
					<input
						type="password"
						value={password}
						onChange={(e) => setPassword(e.target.value)}
						placeholder="Enter password"
						autoFocus
						disabled={loading}
					/>
					{error && <div className="login-error">{error}</div>}
					<button
						type="submit"
						className="btn-primary"
						disabled={loading || !password}
					>
						{loading ? "Logging in..." : "Login"}
					</button>
				</form>
			</div>
		</div>
	);
}
